import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import HowTo1 from '../game/HowTo1';
import HowTo2 from '../game/HowTo2';
import HowTo3 from '../game/HowTo3';
import SoundAssetKeys from '../SoundAssetKeys';
import { dotPop } from '../Utilities';
import Game from './Game';

export default class Instructions extends Phaser.Scene {
    static get KEY() { return 'Instructions'; }

    constructor() {
        super({ key: (Instructions).KEY });
    }

    init() {
        this.curHow = 0;

        this.hows = null;
        this.howto1 = null;
        this.howto2 = null;
        this.howto3 = null;

        this.btnNext = null;
    }

    create() {
        this.add.image(0, 0, "bg").setOrigin(0);

        this.howto1 = new HowTo1(this);
        this.howto2 = new HowTo2(this);
        this.howto3 = new HowTo3(this);

        this.howto1.x = (this.scale.width - this.howto1.workingWidth) / 2;
        this.howto1.y = (this.scale.height - this.howto2.workingHeight) / 2 - 100;

        this.howto2.x = (this.scale.width - this.howto2.workingWidth) / 2;
        this.howto2.y = (this.scale.height - this.howto2.workingHeight) / 2 - 100;

        this.howto3.x = (this.scale.width - this.howto3.workingWidth) / 2;
        this.howto3.y = (this.scale.height - this.howto2.workingHeight) / 2 - 100;

        this.howto1.alpha = this.howto2.alpha = this.howto3.alpha = 0;
        this.add.existing(this.howto1);
        this.add.existing(this.howto2);
        this.add.existing(this.howto3);

        this.btnNext = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height - 120, "BtnNext", this).setOrigin(0.5).setScale(0);

        this.curHow = 0;
        this.hows = [this.howto1, this.howto2, this.howto3];
        ABCyaPhaser.Tweens.addTween(this.hows[this.curHow], 600, { alpha: 1 }, Phaser.Math.Easing.Linear, () => this.activateNext());
    }

    activateNext() {
        dotPop(this.btnNext);
        this.hows[this.curHow].initAnimation();
        this.btnNext.setInteractive().once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickNext, this);
    }

    clickNext() {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
        let t = ABCyaPhaser.Tweens.addTween(this.hows[this.curHow], 500, {alpha: 0}, Phaser.Math.Easing.Linear);
        if (this.curHow < this.hows.length - 1) {
            this.curHow++;
            ABCyaPhaser.Tweens.addTween(this.hows[this.curHow], 600, {alpha: 1}, Phaser.Math.Easing.Linear, ()=> this.activateNext());
        } else {
            t.once(Phaser.Tweens.Events.TWEEN_COMPLETE, ()=> this.scene.start(Game.KEY));
        }
        ABCyaPhaser.Tweens.addTween(this.btnNext, 220, {alpha: 0}, Phaser.Math.Easing.Linear);
    }
}